/**
 * Wraps the description addon tick icon with left spacing.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const DescriptionAddonTickContainer = styled.div`
  margin-left: ${24 * Screen.widthRatio}px;
`;

export default DescriptionAddonTickContainer;
